import { ArrowCircleRightIcon, NewspaperIcon, UsersThreeIcon } from '@phosphor-icons/react';

const VARIANT_CONFIG = {
  mine: {
    icon: NewspaperIcon,
    text: 'View your added solution',
    wrapperClass: 'bg-[var(--q3-blue-light)]',
    textClass: 'text-[var(--q3-blue-normal)]',
    iconClass: 'text-[var(--q3-blue-normal)]',
  },
  others: {
    icon: UsersThreeIcon,
    text: 'View solutions uploaded by other students',
    wrapperClass: 'bg-[var(--q3-blue-light)]',
    textClass: 'text-[var(--q3-blue-normal)]',
    iconClass: 'text-[var(--q3-blue-normal)]',
  },
  none: {
    icon: UsersThreeIcon,
    text: 'Be the first one to add solution for this Qs',
    wrapperClass: 'bg-[var(--q3-accent-light)]',
    textClass: 'text-[var(--q3-accent-normal)]',
    iconClass: 'text-[var(--q3-accent-normal)]',
  },
};

const CommunitySolutionBanner = ({ variant, onClick }) => {
  const config = VARIANT_CONFIG[variant];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
      className={`flex flex-row items-center justify-between gap-3 rounded-xl px-4 py-3 cursor-pointer max-w-[529px] ${config.wrapperClass}`}
    >
      <div className="flex flex-row items-center gap-2">
        <Icon size={24} className={config.iconClass} />
        <span className={`text-sm font-medium ${config.textClass}`}>{config.text}</span>
      </div>
      <div className={`flex items-center justify-center rounded-full`}>
        <ArrowCircleRightIcon size={24} className={config.iconClass} />
      </div>
    </div>
  );
};

export default CommunitySolutionBanner;
